import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getToken } from '../api/client';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const hasSession = isAuthenticated || !!getToken();

  if (loading) {
    return (
      <div className="admin-loading">
        <p>Yükleniyor…</p>
      </div>
    );
  }

  if (!hasSession) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
